export const hasPermission = (userPermissions, permission, user) => {
  // If no permission required → allow
  if (!permission) return true;

  // If admin → allow everything
  if (user?.userName?.toLowerCase() === "admin") return true;

  return userPermissions.includes(permission);
};

export const filterMenuByPermission = (menu, permissions, user) => {
  // If admin → return full menu
  if (user?.userName?.toLowerCase() === "admin") {
    return menu;
  }

  return menu
    .map(item => {
      // Permission check
      if (item.permission && !permissions.includes(item.permission)) {
        return null;
      }

      // Filter children recursively
      let children = item.children;
      if (children) {
        children = filterMenuByPermission(children, permissions, user);
        if (!children.length) return null;
      }

      return {
        ...item,
        icon: item.icon,
        children
      };
    })
    .filter(Boolean);
};
